module.exports = __webpack_public_path__ + "img/zb.40b35601.png";